import React from 'react';
import useUserData from '../../hooks/useUserData';
import {
    Modal,
    Box,
    Typography,
    TextField,
    Button,
    MenuItem,
    InputAdornment,
} from '@mui/material';

import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import PersonOutlineIcon from '@mui/icons-material/PersonOutline';
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import ChatBubbleOutlineIcon from '@mui/icons-material/ChatBubbleOutline';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import useSendCashbackFeedback from '../../hooks/useSendCashbackFeedback';
import { useAlert } from '../../context/AlertContext';

const motivos = [
    'Ajuda com o MeuCupom Devolve',
    'Dúvidas, sugestões ou problemas com o site',
    'Parcerias comerciais',
    'Outro motivo'
];

const FeedbackModal = ({ open, onClose }) => {


    const { user } = useUserData();
    const { sendFeedback, response, loading, error } = useSendCashbackFeedback();
    const { showAlert } = useAlert();

    const [form, setForm] = React.useState({
        motive: motivos[0],
        name: '',   
        email: '',  
        title: '',
        message: ''
    });



    React.useEffect(() => {
        if (user) {
            setForm(prev => ({
                ...prev,
                name: user.name || '',
                email: user.email || '',
            }));
            }
    }, [user]);




    const handleChange = (e) => {
        const { name, value } = e.target;
        setForm(prev => ({ ...prev, [name]: value }));
    };
    
    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!form.name || !form.email || !form.title || !form.motive || !form.message) {
            showAlert("Preencha todos os campos", "warning");
            return;
        }
        await sendFeedback(form);
    };

    return (
        <Modal open={open} onClose={onClose}>
        <Box component="form" onSubmit={handleSubmit} sx={{
            position: 'absolute',
            top: '50%', left: '50%',
            transform: 'translate(-50%, -50%)',
            width: { xs: '90vw', sm: 450 },
            bgcolor: 'background.paper',
            borderRadius: 2,
            boxShadow: 24,
            p: 3,
            display: 'flex',
            flexDirection: 'column',
            gap: 2
        }}>
            <Typography variant="h6" sx={{ fontWeight: 'bold' }}>Fale conosco</Typography>
            <Box>
                <Typography variant="caption" sx={{ fontWeight: 'bold', color: 'text.secondary' }}>MOTIVO DO CONTATO</Typography>
                <TextField
                    select
                    name="motive"
                    value={form.motive}
                    onChange={handleChange}
                    fullWidth
                    size="small"
                    InputProps={{
                    startAdornment: (
                        <InputAdornment position="start" sx={{ bgcolor: '#999', color: '#fff', p: 1, borderRadius: '0 4px 4px 0' }}>
                        <HelpOutlineIcon fontSize="small" />
                        </InputAdornment>
                    )
                    }}
                >
                    {motivos.map((option) => (
                    <MenuItem key={option} value={option}>
                        {option}
                    </MenuItem>
                    ))}
                </TextField>
            </Box>
            <Box>
                <Typography variant="caption" sx={{ fontWeight: 'bold', color: 'text.secondary' }}>NOME</Typography>
                <TextField
                    name="name"
                    value={form.name}
                    onChange={handleChange}
                    fullWidth
                    size="small"
                    InputProps={{
                    startAdornment: (
                        <InputAdornment position="start" sx={{ bgcolor: '#999', color: '#fff', p: 1, borderRadius: '0 4px 4px 0',}}>
                        <PersonOutlineIcon fontSize="small" />
                        </InputAdornment>
                    )
                    }}
                />
            </Box>
            <Box>
                <Typography variant="caption" sx={{ fontWeight: 'bold', color: 'text.secondary' }}>EMAIL</Typography>
                <TextField
                    name="email"
                    type="email"
                    value={form.email}
                    onChange={handleChange}
                    fullWidth
                    size="small"
                    InputProps={{
                    startAdornment: (
                        <InputAdornment position="start" sx={{ bgcolor: '#999', color: '#fff', p: 1, borderRadius: '0 4px 4px 0' }}>
                        <EmailOutlinedIcon fontSize="small" />
                        </InputAdornment>
                    )
                    }}
                />
            </Box>
            <Box>
                <Typography variant="caption" sx={{ fontWeight: 'bold', color: 'text.secondary' }}>ASSUNTO</Typography>
                <TextField
                    name="title"
                    value={form.title}
                    onChange={handleChange}
                    fullWidth
                    size="small"
                    InputProps={{
                    startAdornment: (
                        <InputAdornment position="start" sx={{ bgcolor: '#999', color: '#fff', p: 1, borderRadius: '0 4px 4px 0' }}>
                        <ChatBubbleOutlineIcon fontSize="small" />
                        </InputAdornment>
                    )
                    }}
                />
            </Box>
            <Box>
                <Typography variant="caption" sx={{ fontWeight: 'bold', color: 'text.secondary' }}>MENSAGEM</Typography>
                <TextField
                    name="message"
                    multiline
                    rows={4}
                    value={form.message}
                    onChange={handleChange}
                    fullWidth
                    size="small"
                    InputProps={{
                    startAdornment: (
                        <InputAdornment position="start" sx={{ bgcolor: '#999', color: '#fff', p: 1, borderRadius: '0 4px 4px 0', height: 'auto', alignSelf: 'flex-start' }}>
                        <EditOutlinedIcon fontSize="small" />
                        </InputAdornment>
                    )
                    }}
                />
            </Box>
            <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 1 }}>
            <Button onClick={onClose}>Fechar</Button>
            <Button variant="contained" type="submit">Enviar</Button>
            </Box>
        </Box>
        </Modal>
    );
};
export default FeedbackModal;
